import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Tache1 from '../assets/images/tache1.svg';
import Tache2 from '../assets/images/tache2.svg';
import Tache3 from '../assets/images/tache3.svg';

interface Splatter {
  id: number;
  x: number;
  y: number;
  image: string;
  rotation: number;
  size: number;
  opacity: number;
  scaleX: number;
  scaleY: number;
}

const MouseHalo = () => {
  const [splatters, setSplatters] = useState<Splatter[]>([]);
  const [lastSplatterTime, setLastSplatterTime] = useState(0);

  const tacheImages = [Tache1, Tache2, Tache3];

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const now = Date.now();
      // Ajouter une tache tous les 100ms pour ne pas surcharger
      if (now - lastSplatterTime > 100) {
        const newSplatter: Splatter = {
          id: now,
          x: e.clientX + window.scrollX + (Math.random() - 0.5) * 40, // Décalage plus grand
          y: e.clientY + window.scrollY + (Math.random() - 0.5) * 40,
          image: tacheImages[Math.floor(Math.random() * tacheImages.length)],
          rotation: Math.random() * 360,
          size: 10 + Math.random() * 30, // Taille entre 10 et 40px pour plus de variation
          opacity: 0.3 + Math.random() * 0.4, // Opacité entre 0.3 et 0.7
          scaleX: 0.7 + Math.random() * 0.6, // scaleX entre 0.7 et 1.3
          scaleY: 0.7 + Math.random() * 0.6, // scaleY entre 0.7 et 1.3
        };

        setSplatters(prev => [...prev, newSplatter]);
        setLastSplatterTime(now);

        // Supprimer la tache après 2 secondes
        setTimeout(() => {
          setSplatters(prev => prev.filter(s => s.id !== newSplatter.id));
        }, 2000);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [lastSplatterTime]);

  return (
    <>
      <AnimatePresence>
        {splatters.map(splatter => (
          <motion.img
            key={splatter.id}
            src={splatter.image}
            alt=""
            initial={{ opacity: 0, scale: 0, rotate: splatter.rotation }}
            animate={{
              opacity: splatter.opacity,
              scale: 1,
              scaleX: splatter.scaleX,
              scaleY: splatter.scaleY,
              rotate: splatter.rotation
            }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.3 }}
            style={{
              position: 'absolute',
              left: splatter.x,
              top: splatter.y,
              width: `${splatter.size}px`,
              height: `${splatter.size}px`,
              transform: `translate(-50%, -50%)`,
              pointerEvents: 'none',
              zIndex: 9999,
            }}
          />
        ))}
      </AnimatePresence>
    </>
  );
};

export default MouseHalo;